/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer } from "react";
import { mapAndJoinArray } from "../../../util/helperFunctions";


import * as R from "rambda";
const sensor_filter = `sensor.excludeFromUi = 0`

const emptyState = () => {
    const filtered_Data = JSON.parse(sessionStorage.getItem('alertFilterValues'));
    return {
        site: (filtered_Data && filtered_Data['site']) ? [...filtered_Data['site']] : [],
        unit: (filtered_Data && filtered_Data['unit']) ? [...filtered_Data['unit']] : [],
        productionUnit: (filtered_Data && filtered_Data['productionUnit']) ? [...filtered_Data['productionUnit']] : [],
        equipment: (filtered_Data && filtered_Data['equipment']) ? [...filtered_Data['equipment']] : [],
        cml: (filtered_Data && filtered_Data['cml']) ? [...filtered_Data['cml']] : [],
        alertStatus: (filtered_Data && filtered_Data['alertStatus']) ? [...filtered_Data['alertStatus']] : [],
        category: (filtered_Data && filtered_Data['category']) ? [...filtered_Data['category']] : [],
    };
}

const reducer = (state, action) => {
    switch (action.type) {
        case "site":
            return { ...state, site: action.value };
        case "productionUnit":
            return { ...state, productionUnit: action.value };
        case "unit":
            return { ...state, unit: action.value };
        case "equipment":
            return { ...state, equipment: action.value };
        case "alertStatus":
            return { ...state, alertStatus: action.value };
        case "cml":
            return { ...state, cml: action.value };
        case "category":
            return { ...state, category: action.value };
        case "clear":
            return emptyState();
        default:
            throw Error("Unrecognized action: " + action.type);
    }
};

const applyFilter = (key, value) => {
    const mapAndJoinArray = (arr) => {
                return arr.map(item => `'${item.value}'`).join(", ");
            };
    switch (key) {
        case "unit":
            return `sensor.unit IN  (${mapAndJoinArray(value)})`;
        case "site":
            return `sensor.site IN  (${mapAndJoinArray(value)})`;
        case "productionUnit":
            return `sensor.productionUnit IN  (${mapAndJoinArray(value)})`;
        case "equipment":
            return `sensor.equipment IN  (${mapAndJoinArray(value)})`;
        case "alertStatus":
            return `sensor.status IN  (${mapAndJoinArray(value)})`;
        case "cml":
            return `sensor.conditionMonitoringLocation IN  (${mapAndJoinArray(value)})`;
        case "category":
            return `category IN  (${mapAndJoinArray(value)})`;
        default:
            throw Error("Unhandled filter field: " + key);
    }
};

const checkEmpty = (field) => {
    return (
        field === undefined ||
        field === "" ||
        field == null ||
        (field.length != null && field.length === 0)
    );
};

export const useFilterAlertState = () => {
    return useReducer(reducer, emptyState());
};

export const filterAlertsLogic = (source) => {
    console.log("filterAlertsLogic called with source:", source);
    const filters = R.keys(source).map((key) => {
        const isEmpty = checkEmpty(source[key]);
        return !isEmpty ? applyFilter(key, source[key]) : null;
    });

    const result = R.filter(R.identity, filters).join(" AND ");

    return result;
};

export function useUpdatedFilterValues(filter, filterFormValues, getOptionsForFilter, updateFilters, noFilter) {
    // Get the current options for this filter
    const currentOptions = getOptionsForFilter(filter);

    // Filter out any selected values that are no longer in the updated options
    let updatedValues = filterFormValues[filter]
        ? filterFormValues[filter].filter(value =>
            currentOptions.find(option => option.value === value.value)
        )
        : [];

    if (updatedValues?.length > 0) {
        updatedValues = updatedValues.map(value => currentOptions.find(option => option && option.value === value.value))

    }

    // Update the filter form values
    useEffect(() => {
        if (!noFilter) {
            updateFilters({ type: filter, value: updatedValues });
        }
    }, [currentOptions]);

    return updatedValues;
}